import React, { useContext, useEffect, useState } from 'react';
import DataTable from "react-data-table-component";
import axiosIntance from '../../../config/axios'
import { RootContext } from '../../../App';
import refactorStructureData from '../../../helpers/refactorDataMenu';
import { Card, CardBody, CardHeader } from "@material-tailwind/react";
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import Swal from "sweetalert2";

const NewAdminRoleMenu = () => {

    const [data , setData] = useState([])
    const [pending , setPending] = useState(true)
    const token = localStorage.getItem("access_token")
    const group = JSON.parse(localStorage.getItem("group"))
    const {state , setState} = useContext(RootContext)
    const param = useParams();

    function handleAddMenu(menuid){

        axiosIntance.post('update_role_menu' , {
            token :token ,
            group :group.wbid,
            roleid: param.roleid,
            menuid: menuid
        }).then((res)=>{

            if(res.data.code === 0){

                Swal.fire("Success", 'New Role Menu Add To this role', 'success').then(() => {

                    setPending(false)
                    setData(res.data.data.list)
                    setState({
                        ...state,
                        group: res.data.data.additional_data.group,
                        menu: refactorStructureData(res.data.data.additional_data.menu),
                    })
                })
            }else if(res.data.code === 400){

                Swal.fire("Warning", 'This Menu Already in this role', 'warning').then(() => {

                    setPending(false)
                    setState({
                        ...state,
                        group: res.data.data.additional_data.group,
                        menu: refactorStructureData(res.data.data.additional_data.menu),
                    })
                })
            }else{

                Swal.fire("Error", 'Internal Server Error', 'error')
            }
        })
        
    }

    useEffect(()=>{
    axiosIntance.post('get_menu_list' , {
      token :token ,
      group :group.wbid
    }).then((res)=>{

      setPending(false)
      setData(res.data.data.list)
      setState({
        ...state,
        group: res.data.data.additional_data.group,
        menu: refactorStructureData(res.data.data.additional_data.menu),
      })
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

    const columns = [
        {
            name: "Menu Root",
            selector: (row) => row.menu_root ? row.menu_root : "Not Found",
            sortable: false,
        },
        {
            name: "Menu Name",
            selector: (row) => row.menu_name ? row.menu_name : "Not Found",
            sortable: false,
        },
        {
            name: "Description",
            selector: (row) => {
                let desc = row.description ? row.description : ""
                return desc;
            },
            sortable: false,
        },
        {
            name: "Add To Role",
            selector: (row) => {

                return <button className='w-14 h-7 bg-green-500 rounded-md text-white' onClick={() => {

                    handleAddMenu(row.mn_id)
                }}>Add</button>
            },
            sortable: false,
        },
        
    ]

  return (
    <Card>
        <CardHeader color="blueGray" contentPosition="left">
            <h2 className="text-white text-2xl">Add New Menu To Role</h2>
        </CardHeader>
        <CardBody >
            <div className='w-full h-auto border-2 border-gray-800 border-solid rounded-md flex flex-col'>
                <div className='w-full h-20 bg-gray-600 px-10 flex items-center'>
                    <div className='text-[24px] text-white'>
                        Menu List
                    </div>
                </div>
                <DataTable
                    columns={columns}
                    data={data}
                    progressPending={pending}
                />
            </div>
        </CardBody>
    </Card>
  )
}

export default NewAdminRoleMenu